module.exports = __webpack_public_path__ + "static/media/lights.dbaf9066.jpg";